import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSEO } from "@/lib/hooks";
import { trackEvent } from "@/lib/track";

export default function ZonesPage() {
  const [data, setData] = useState({ departments: [], cities: [] });
  useSEO({ title: "Zones d'intervention — Dépannage Remorquage Île-de-France", description: "Liste des départements et villes couverts par notre service de dépannage et remorquage 24h/24 en Île-de-France." });
  useEffect(() => { api.get("/zones").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <h1 className="text-3xl lg:text-4xl font-extrabold">Zones d'intervention</h1>
          <p className="text-ink-300 mt-2 max-w-2xl">Notre service couvre l'ensemble de l'Île-de-France 24h/24 et 7j/7.</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 lg:px-6 py-12">
        <h2 className="text-xl font-extrabold text-txt-900 mb-5">Départements</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {data.departments.map((d) => (
            <Link
              key={d.slug}
              to={`/departement/${d.slug}`}
              onClick={() => trackEvent("click_department", d.slug, { label: d.name })}
              className="bg-white border border-surface-200 hover:border-brand rounded-2xl p-5 group transition-all hover:shadow-card"
              data-testid={`dept-card-${d.code}`}
            >
              <div className="text-3xl font-extrabold text-brand">{d.code}</div>
              <div className="font-bold text-txt-900 mt-1">{d.name}</div>
              <div className="text-txt-500 text-xs mt-2 group-hover:text-brand transition-colors">Voir le détail &rarr;</div>
            </Link>
          ))}
        </div>

        <h2 className="text-xl font-extrabold text-txt-900 mt-12 mb-5">Villes principales</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
          {data.cities.map((c) => (
            <Link
              key={c.slug}
              to={`/depannage-remorquage-${c.slug}`}
              className="bg-surface-50 hover:bg-brand-50 rounded-xl px-4 py-3 text-sm font-medium flex items-center justify-between transition-colors"
              data-testid={`city-link-${c.slug}`}
            >
              <span className="text-txt-900">{c.city}</span>
              <span className="text-brand text-xs font-bold">{c.department_code}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
